import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_inventory_by_licenseplate_selection_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { warehouseId: number, projectId: number, fullTextSearch?: string, lotStatusId?: number, licenseplateStatusId?: number, elligible_for_allocation?: boolean }): 
  Promise<{ result: { Id?: number, GrossWeight?: number, LookupCode?: string, WarehouseId?: number, WeightUomId?: number, Location?: { EligibleForAllocation?: boolean, Name?: string }, Warehouse?: { Name?: string }, LicensePlateContents?: { PackagedId?: number, PackagedAmount?: number, Lot?: { Id?: number, VendorLotId?: number } }[], Status?: { Name?: string }, measurement_unit?: { Id?: number, Name?: string, Short_name?: string }[], TotalPackagedAmount?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.warehouseId)) {
      $missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil($inParams.projectId)) {
      $missingRequiredInParams.push('\'projectId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { warehouseId: number, projectId: number, fullTextSearch?: string, lotStatusId?: number, licenseplateStatusId?: number, elligible_for_allocation?: boolean, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, GrossWeight?: number, LookupCode?: string, WarehouseId?: number, WeightUomId?: number, Location?: { EligibleForAllocation?: boolean, Name?: string }, Warehouse?: { Name?: string }, LicensePlateContents?: { PackagedId?: number, PackagedAmount?: number, Lot?: { Id?: number, VendorLotId?: number } }[], Status?: { Name?: string }, measurement_unit?: { Id?: number, Name?: string, Short_name?: string }[], TotalPackagedAmount?: number }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.warehouseId)) {
      $missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil($inParams.projectId)) {
      $missingRequiredInParams.push('\'projectId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { warehouseId: number, projectId: number, fullTextSearch?: string, lotStatusId?: number, licenseplateStatusId?: number, elligible_for_allocation?: boolean, $keys: number[] }): 
  Promise<{ result: { Id?: number, GrossWeight?: number, LookupCode?: string, WarehouseId?: number, WeightUomId?: number, Location?: { EligibleForAllocation?: boolean, Name?: string }, Warehouse?: { Name?: string }, LicensePlateContents?: { PackagedId?: number, PackagedAmount?: number, Lot?: { Id?: number, VendorLotId?: number } }[], Status?: { Name?: string }, measurement_unit?: { Id?: number, Name?: string, Short_name?: string }[], TotalPackagedAmount?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.warehouseId)) {
      $missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil($inParams.projectId)) {
      $missingRequiredInParams.push('\'projectId\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      warehouseId: number, projectId: number, fullTextSearch?: string, lotStatusId?: number, licenseplateStatusId?: number, elligible_for_allocation?: boolean    }) {
        if(isNil($inParams.warehouseId)) {
          return true; 
        }
        if(isNil($inParams.projectId)) {
          return true; 
        }
      return false;
    }
}
